export enum QueryParameters {
  TPCI_YOULEND = 'tpci',
  TPCI_NLGROEIT = 'tpci_nlg',
}
